import Axios from "../utils/tms-axios/tms-axios";

const walkersService = {
  getWalkersTagSerialAll: async (page, limit) => {
    const resp = await Axios.get(
      `em/walkers-tag-serial/all?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  createWalkersTagSerial: async (body) => {
    const resp = await Axios.post(`em/walkers-tag-serial/create`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getWalkersCounters: async (page, limit) => {
    const resp = await Axios.get(
      `em/walkers-counter/all?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  createWalkersCounter: async (body) => {
    const resp = await Axios.post(`em/walkers-counter/create`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  deleteWalkerCounter: async (id) => {
    const resp = await Axios.delete(`em/walkers-counter/delete/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  createWalkerTagUser: async (body) => {
    const resp = await Axios.post(`em/walkers-tag-user/create`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  createChildernTagUser: async (body) => {
    const resp = await Axios.post(`em/children-tag-user`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getWalkerTagScanner: async (walkerTagId) => {
    const resp = await Axios.get(`em/walkers-tag-scan/scan/${walkerTagId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  getChildTagScanner: async (childTagId) => {
    const resp = await Axios.get(`em/children-tag-scan/scan/${childTagId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  //Children
  getChildrenTagSerialAll: async (page, limit) => {
    const resp = await Axios.get(
      `em/children-tag-serial?page=${page}&limit=${limit}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          "X-Temple-Id": localStorage.getItem("templeId"),
        },
      }
    );
    return resp.data;
  },

  createChildrenTagSerial: async (body) => {
    const resp = await Axios.post(`em/children-tag-serial`, body, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },

  getChildrenTagScanner: async (walkerTagId) => {
    const resp = await Axios.get(`em/children-tag-scan/scan/${walkerTagId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  getChildrenLogs: async (walkerTagId) => {
    const resp = await Axios.get(`em/children-tag-scan/scan/${walkerTagId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
  getWalkerLogs: async (fromDate, toDate, page, limit, counterId) => {
    let url = `em/walkers-tag-scan/logs?page=${page}&limit=${limit}&fromDate=${fromDate}&toDate=${toDate}`;
    if (counterId) {
      url = url + `&counterId=${counterId}`;
    }
    const resp = await Axios.get(url, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        "X-Temple-Id": localStorage.getItem("templeId"),
      },
    });
    return resp.data;
  },
};

export default walkersService;
